module.exports = __webpack_public_path__ + "img/slide-6-guide-patients-experiencing-2.7f950884.png";